import { Divider, Paper, Typography, colors } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import gql from 'graphql-tag';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { AccountWallet, CreditCard, Payline, PaymentProvider, helpers } from '@aps-management/primapp-common';

import Payment from '_components/Payment';
import { Screen } from '_components/core';
import { DialogPaymentIP, PaylineWidgetFrame } from '_components/elements';
import apolloClient from '_utils/apolloClient';
import { buildAccountWalletDeliveryIntent } from '_utils/deliveryIntent';
import i18n from '_utils/i18n';
import masterClient from '_utils/masterClient';
import { assertWidgetPaymentSuccess } from '_utils/paymentGuard';

/* */
import { PAYLINE_FLOW_TYPES, setupPaylineListeners } from '../../services/payline';

/* */
const styles = (theme) => ({
  loaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
    justifyContent: 'center',
  },
  divider: {
    margin: `${theme.spacing.unit * 1.5}px 0`,
  },
  paymentSummaryBlock: {
    marginBottom: `${theme.spacing.unit * 4}px`,
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
    display: 'flex',
    flexDirection: 'column',
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

/* */

/* */
class AccountWalletPayment extends React.Component {
  /* */
  constructor(props) {
    super(props);

    const { golf, account, cart } = this.props;

    [this.product] = cart;

    // build session 3DS
    this.session3DS = {
      address: {
        city: golf.city,
        countryCode: 250, // golf.country
        line1: golf.name,
        zipCode: golf.postalCode,
      },
      customer: {
        email: account.email,
        lastName: account.lastname,
        firstName: account.firstname,
        phone: account.phone,
      },
    };
    this.currency = golf.currency;

    this.state = {
      // Screen
      error: null,
      loading: true,
      // Payment
      status: null,
      imprint: null,
      waiting: false,
      paylineToken: null,
    };

    this.paylineWidgetData = null;
    this.isPaylinePaymentHandled = false;
    this.removePaylineListeners = null;
  }

  /* */
  componentDidMount() {
    CreditCard.api
      .getCreditCards(apolloClient)
      .then(({ creditCards }) => {
        // Garde-fou : seule une carte disposant d'un wallet Payline réel (walletId) peut
        // être débitée en 1 clic. Une carte sans walletId (enregistrée avant le correctif
        // ou via un chemin legacy) produirait subscriber.id=null : mutation rejetée. On ne
        // la propose donc pas : l'utilisateur ressaisit sa carte (le widget crée un vrai
        // wallet), ce qui répare la situation de lui-même.
        const usable = (creditCards || []).find((c) => c && c.walletId);
        if (usable) {
          this.setState({ imprint: usable });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  /*
   * Les écouteurs posés par `setupPaylineListeners` vivent sur `window`, pas sur
   * le composant : sans cette libération, ils SURVIVENT au démontage de l'écran.
   * Un aller-retour (retour au solde puis nouvelle tentative) laissait alors deux
   * instances à l'écoute du même widget ; au succès, les deux rejouaient la
   * chaîne complète capture -> enregistrement de carte -> crédit du compte.
   * Chacune ayant son propre `isPaylinePaymentHandled` et son propre
   * `paylineWidgetData`, le garde-fou par instance ne voyait rien. Un seul débit,
   * deux crédits : incident Golf aux Daims du 25/07/2026.
   */
  componentWillUnmount() {
    if (this.removePaylineListeners) {
      this.removePaylineListeners();
      this.removePaylineListeners = null;
    }
  }

  /* */
  creditWallet(creditCardTransaction) {
    const { golf, account } = this.props;

    return AccountWallet.api.createOperation(masterClient, {
      creditCardTransaction,
      golfId: golf.id,
      accountId: account.id,
      product: helpers.object.filterByKeys(this.product, ['id', 'name', 'refilledAmount', 'paidAmount']),
    });
  }

  /* */
  goToVoucher = () => this.props.history.push('/accountwallet/payment/voucher');

  /*
  values : {
    brand
    country
    cvv
    dueDate
    id3D
    number
    saveImprint
    type
  }
  */
  payWithNewCard = (values, { setSubmitting }) => {
    const { refilledAmount, paidAmount } = this.product;
    const { golf } = this.props;

    const { id3D = null, ...creditCard } = values;
    const creditCardMapped = {
      ...creditCard,
      name: '3DS web',
      number: values.number.replace(/\s/g, ''),
      dueDate: values.dueDate.replace(/\D/g, ''),
    };

    this.setState({
      error: null,
      waiting: true,
      status: 'Nous interrogeons votre banque...',
    });

    const creditCardTransaction = {
      id3D,
      amount: paidAmount,
      currency: this.currency,
      creditCard: creditCardMapped,
      provider: 'payline',
    };

    return this.creditWallet(creditCardTransaction)
      .then(({ transaction }) => {
        this.props.addTransaction({
          transaction,
          refilledAmount,
        });
        this.goToVoucher();
      })
      .catch((err) => {
        this.setState({
          waiting: false,
          error: err.message,
        });
        setSubmitting(false);
      });
  };

  payWithNewCardPayline = () => {
    const { paidAmount } = this.product;
    const { account } = this.props;
    const data = {
      amount: paidAmount,
      id: helpers.uuid.createUuid(),
    };

    this.setState({
      error: null,
      waiting: true,
      status: 'Nous préparons le paiement...',
    });

    const baseUrl = window.location.origin;
    const timestamp = Number(new Date());
    const shortId = account.id.split('-')[0];

    return Payline.api
      .getToken(apolloClient, {
        amount: paidAmount,
        reference: `AW-${shortId}-${timestamp}`,
        /*
         * Décrit le rechargement pour que master puisse créditer sans le
         * navigateur. C'est le parcours où son absence coûte le plus : l'argent
         * part au widget, et le crédit du compte, la commande et la ligne de
         * paiement dépendent tous du retour ici.
         */
        deliveryIntent: buildAccountWalletDeliveryIntent({
          product: this.product,
          golf: this.props.golf,
          account,
        }),
        returnUrl: `${baseUrl}/accountwallet/payment/voucher`,
        cancelUrl: `${baseUrl}/accountwallet/payment`,
        callbackUrl: `${baseUrl}/payline/callback`,
        customer: {
          firstName: account.firstname,
          lastName: account.lastname,
          email: account.email,
          phone: account.phone,
        },
      })
      .then((res) => {
        if (!res?.token) {
          throw new Error('Token de paiement introuvable.');
        }

        data.token = res.token;
        this.setState({
          paylineToken: data.token,
          waiting: false,
          status: null,
        });

        this.paylineWidgetData = data;
        this.isPaylinePaymentHandled = false;

        if (this.removePaylineListeners) {
          this.removePaylineListeners();
        }

        this.removePaylineListeners = setupPaylineListeners(PAYLINE_FLOW_TYPES.CHECKOUT, {
          onSuccess: (eventData) => this.handlePaylinePaymentSuccess(eventData),
          onFailure: (eventData) =>
            this.handlePaylinePaymentError(eventData, 'Le paiement a échoué. Veuillez réessayer.'),
          onCancel: (eventData) => this.handlePaylinePaymentError(eventData, 'Le paiement a été annulé.'),
        });
      })
      .catch((err) => {
        this.setState({
          error: err.message,
          waiting: false,
          status: null,
          paylineToken: null,
        });
      });
  };

  /*
  imprint: {
    brand
    country
    dueDate
    id
    isExpired
    isSoonExpired
    name
    number
    token
    type
  }
  */
  payWithCardImprint = () => {
    const { imprint } = this.state;
    const { refilledAmount, paidAmount } = this.product;

    // Garde-fou (défense en profondeur) : ne jamais tenter un paiement 1-clic avec une
    // carte dépourvue de wallet Payline réel. Normalement déjà filtré au chargement.
    if (!imprint || !imprint.walletId) {
      this.setState({
        error:
          "Cette carte enregistrée n'est plus utilisable pour le paiement en 1 clic. Réglez avec une nouvelle carte : elle sera ré-enregistrée automatiquement.",
      });
      return Promise.resolve();
    }

    this.setState({
      error: null,
      waiting: true,
      status: 'Nous interrogeons votre banque...',
    });

    const creditCardTransaction = {
      amount: paidAmount,
      currency: this.currency,
      subscriber: {
        ...helpers.object.filterByKeys(imprint, ['token', 'dueDate', 'number', 'type', 'brand', 'country']),
        id: imprint.walletId,
      },
      provider: 'payline',
    };

    // Direct server-to-server payment via doImmediateWalletPayment (action=128 COF).
    // No widget, no 3DS challenge - the backend handles the payment directly.
    return this.creditWallet(creditCardTransaction)
      .then(({ transaction }) => {
        this.props.addTransaction({
          transaction,
          refilledAmount,
        });
        this.goToVoucher();
      })
      .catch((err) => {
        this.setState({
          waiting: false,
          error: err.message,
        });
      });
  };

  /* */
  handlePaylinePaymentSuccess = (eventData = {}) => {
    if (this.isPaylinePaymentHandled || !this.paylineWidgetData) {
      return;
    }

    this.isPaylinePaymentHandled = true;

    const data = this.paylineWidgetData;
    const token = eventData?.token || data.token;
    const saveImprint = sessionStorage.getItem('payline_saveImprint') === '1';

    // Drapeau de capture : sépare l'échec RÉCUPÉRABLE (avant tout mouvement d'argent)
    // de l'échec AVAL (encaissement accepté, un rejeu débiterait une seconde fois).
    let captureSucceeded = false;

    this.setState({ paylineToken: null });
    this.paylineWidgetData = null;
    if (this.removePaylineListeners) {
      this.removePaylineListeners();
      this.removePaylineListeners = null;
    }

    this.setState({
      error: null,
      waiting: true,
      status: 'Vérification du paiement...',
    });

    const processPayment = saveImprint
      ? Payline.api.captureWithToken(apolloClient, {
          token,
          amount: data.amount,
          uuid: data.id,
          reference: data.id,
          customer: {
            firstName: this.props.account.firstname,
            lastName: this.props.account.lastname,
            email: this.props.account.email,
          },
        })
      : Payline.api.checkPayment(apolloClient, { token });

    return processPayment
      .then((result) => {
        // Même trou que sur l'écran Practice : `paylineCheckPayment` renvoie un
        // paiement REFUSÉ en résolution normale (`status: 'failed'`), et le compte
        // client était crédité malgré tout. Cf. `_utils/paymentGuard`.
        assertWidgetPaymentSuccess(result, 'AccountWallet.widgetPayment');

        // L'argent est pris. Tout ce qui suit (enregistrement de la carte, crédit du
        // compte) peut échouer sans que cela redonne le droit de payer.
        captureSucceeded = true;

        const transaction = {
          amount: data.amount,
          currency: this.currency,
          provider: 'payline',
          mode: 0,
          callNo: result.authorizationNumber,
          transactionNo: result.transactionId,
          card: result.maskedCardNumber,
          brand: result.cardBrand,
          country: result.cardCountry,
        };

        if (saveImprint) {
          this.setState({ status: 'Enregistrement de la carte...' });
          return CreditCard.api
            .setCreditCard(apolloClient, {
              id: data.id,
              token: result.token || token,
              number: result.maskedCardNumber,
              name: 'Payline',
              dueDate: result.expiryDate ? result.expiryDate : result.expirationDate ? result.expirationDate : '0000',
              brand: result.cardBrand,
              country: result.cardCountry,
              walletId: result.walletId,
              paymentRecordId: result.transactionId,
            })
            .then(() => {
              sessionStorage.removeItem('payline_saveImprint');
              return CreditCard.api
                .getCreditCards(apolloClient)
                .then(({ creditCards }) => {
                  if (creditCards && creditCards.length > 0) {
                    this.setState({ imprint: creditCards[0] });
                  }
                })
                .catch(() => {});
            })
            .then(() => {
              this.setState({ status: 'Nous confirmons votre rechargement...' });

              return this.creditWallet(transaction).then(({ transaction: creditTransaction }) => {
                this.props.addTransaction({
                  transaction: creditTransaction,
                  refilledAmount: this.product.refilledAmount,
                });
                this.goToVoucher();
              });
            });
        }

        sessionStorage.removeItem('payline_saveImprint');
        this.setState({
          status: 'Nous confirmons votre rechargement...',
        });

        return this.creditWallet(transaction).then(({ transaction: creditTransaction }) => {
          this.props.addTransaction({
            transaction: creditTransaction,
            refilledAmount: this.product.refilledAmount,
          });
          this.goToVoucher();
        });
      })
      .catch((err) => {
        // Ne relâcher le verrou que si RIEN n'a été encaissé. Après un encaissement
        // accepté (échec de setCreditCard, du crédit du compte ou du réseau), on garde
        // le verrou fermé : l'argent est parti, un rejeu doublerait le débit.
        if (!captureSucceeded) {
          this.isPaylinePaymentHandled = false;
        }
        this.setState({
          error: captureSucceeded
            ? `${err.message} Votre paiement a bien été pris en compte : ne le renouvelez pas, contactez le golf.`
            : err.message,
          waiting: false,
          status: null,
        });
      });
  };

  handlePaylinePaymentError = (eventData = {}, defaultMessage = 'Le paiement a échoué. Veuillez réessayer.') => {
    this.setState({ paylineToken: null });
    this.paylineWidgetData = null;
    if (this.removePaylineListeners) {
      this.removePaylineListeners();
      this.removePaylineListeners = null;
    }

    this.setState({
      waiting: false,
      status: null,
      error: eventData?.message || defaultMessage,
    });

    this.isPaylinePaymentHandled = false;
  };

  /* */
  render() {
    const { cart } = this.props;
    if (!cart || cart.length === 0) {
      return <Redirect to='/account/statement' />;
    }

    const { error, status, imprint, loading, waiting } = this.state;
    const { paidAmount, refilledAmount } = this.product;
    const { classes, balance } = this.props;

    const currentAmountColor = balance < 0 ? colors.red[500] : colors.green[500];
    const futureAmountColor = balance + refilledAmount < 0 ? colors.red[500] : colors.green[500];

    return (
      <Screen error={error} loading={loading} title='Rechargement du compte client - Paiement par CB'>
        <Paper className={classes.paymentSummaryBlock}>
          <Typography variant='h5' className={classes.line} align='center'>
            {'Solde actuel'}
            <span style={{ color: currentAmountColor }}>{i18n.l('currency', balance / 100)}</span>
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant='h5' className={classes.line} align='center'>
            {'Solde futur'}
            <span style={{ color: futureAmountColor }}>{i18n.l('currency', (balance + refilledAmount) / 100)}</span>
          </Typography>
        </Paper>
        <Payment
          amount={paidAmount}
          golf={this.props.golf}
          imprint={imprint}
          currency={this.currency}
          session3DS={this.session3DS}
          isPaylineProvider={PaymentProvider.isPayline(this.props.golf)}
          payWithNewCard={this.payWithNewCard}
          payWithNewCardPayline={this.payWithNewCardPayline}
          payWithCardImprint={this.payWithCardImprint}
        />
        {this.state.paylineToken && (
          <PaylineWidgetFrame
            token={this.state.paylineToken}
            options={{ flowType: PAYLINE_FLOW_TYPES.CHECKOUT, amount: paidAmount }}
            title='Payline Widget'
          />
        )}
        <DialogPaymentIP open={waiting} status={status} />
      </Screen>
    );
  }
}

const mapStateToProps = ({ app: { account, golf }, accountWallet: { cart, clientId, balance } }) => ({
  cart,
  golf,
  account,
  clientId,
  balance,
});

const StyledComponent = withStyles(styles)(AccountWalletPayment);

export default connect(mapStateToProps, AccountWallet.actions)(StyledComponent);
